import { NgModule } from '@angular/core';
import { DocumentsApiService } from './services/documents-api.service';
import { DocumentsComponent } from './components/documents/documents.component';
import { DocumentsViewerComponent } from './components/documents-viewer/documents-viewer.component';
import { DownloadsModalComponent } from './components/downloads-modal/downloads-modal.component';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { DocumentsState } from './states/documents.state';
import {
  ButtonDirective,
  IconComponent,
  ModalCloseButtonDirective,
  ModalComponent,
  ModalContentDirective,
  ModalTitleDirective,
  SvgAtlasComponent
} from '@bioreferencehealth/ui-kit';

@NgModule({
  providers: [DocumentsApiService],
  imports: [
    DocumentsComponent,
    DocumentsViewerComponent,
    DownloadsModalComponent,
    CommonModule,
    ButtonDirective,
    NgxsModule.forFeature([DocumentsState]),
    IconComponent,
    SvgAtlasComponent,
    ModalComponent,
    ModalTitleDirective,
    ModalContentDirective,
    ModalCloseButtonDirective
  ]
})
export class DocumentsModule {}
